import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'RIGHT',
  category: FunctionCategory.TEXT,
  description: 'Substring from the end of each string in a column or a single string.',
  shortDescription: 'Substring from the end of a string',
  params: [
    {
      name: 'value',
      type: ArgType.text,
      description: 'Either a column or string to substring.',
    },
    {
      name: 'number_of_characters',
      type: ArgType.number,
      description: 'Either a column or number, number of characters to use in the substring.',
    },
  ],
} satisfies AnalysisFunction;
